import { get } from '../../utils/http'

export function feeValues() {
    return get('/fee/feeValues');
}
